import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import InventoryCheckLists from './components/InventoryCheckLists';

const inventoryCheckLists = (props,{ t }) => (
  <Container>
    <InventoryCheckLists {...props} />
  </Container>
);

inventoryCheckLists.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(inventoryCheckLists);
